import { render, staticRenderFns } from "./Interventi.vue?vue&type=template&id=0aef9c98&scoped=true&"
import script from "./Interventi.vue?vue&type=script&lang=js&"
export * from "./Interventi.vue?vue&type=script&lang=js&"
import style0 from "./Interventi.vue?vue&type=style&index=0&id=0aef9c98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aef9c98",
  null
  
)

export default component.exports